import firebase from "firebase";
import 'firebase/functions'

// Creates a firebase object used throughout the application
var config = {
    apiKey: "AIzaSyBcW19kL5zbAJRBQAxrky9BqpvEWzWNmdc",
    authDomain: "my-mozak.firebaseapp.com",
    databaseURL: "https://my-mozak.firebaseio.com",
    projectId: "my-mozak",
    storageBucket: "my-mozak.appspot.com",
    messagingSenderId: "1063867977708"
  };

  console.log(firebase);

export const firebaseApp = firebase.initializeApp(config);

const messaging = firebase.messaging();
messaging.requestPermission()
.then(function() {
  return messaging.getToken();
})
.then(function(token) {
})
.catch(function(err) {
  console.log('Error')
})

messaging.onMessage(function(payload) {
  console.log(payload);
})



// WEBPACK FOOTER //
// ./src/firebase/firebase.js